//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import BusinessIcon from "@material-ui/icons/Business";
import SaveConfigurationButton from "src/components/loader/buttons/SaveConfigurationButton";
import UploadFileWithConfigurationButton from "src/components/loader/buttons/UploadFileWithConfigurationButton";

const FixLayoutButton = (props) => {
  return (
    <UploadFileWithConfigurationButton
      label="Fix Selected Layouts"
      url="loader/fixLayouts"
      icon={<BusinessIcon />}
      {...props}
    />
  );
};
export default FixLayoutButton;
